import { ComponentProps, useCallback } from 'react';

import { UserInfo as UserInfoLib } from '@pletly/ui';
import { useAuthHeaders } from '%hooks/auth';
import { navigationRef } from '%services/navigation';

export const UserInfo = ({ id, photoUrl, onPress, ...userInfoProps }: Props) => {
	const { getHeaders } = useAuthHeaders();
	const { navigate } = navigationRef;

	const defaultOnPress = useCallback(() => {
		if (!id) {
			return;
		}
		navigate('Profile', {
			userId: id,
		});
	}, [id, navigate]);

	const source = photoUrl ? { uri: photoUrl, headers: getHeaders(photoUrl) } : undefined;

	return (
		<UserInfoLib photoSource={source} onPress={onPress || defaultOnPress} {...userInfoProps} />
	);
};

type Props = ComponentProps<typeof UserInfoLib> & {
	photoUrl?: string | null;
};
